import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-6 bg-white px-4">
        <div className="flex flex-col items-center gap-2">
          <h1 className="font-heading text-3xl sm:text-4xl font-black tracking-tight" data-testid="loader-text">
            LAND DRAFTERS
          </h1>
          <p className="font-mono text-base sm:text-lg uppercase tracking-widest text-zinc-600 flex items-center gap-1">
            <span>Loading</span>
            <LoadingDots />
          </p>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}

function LoadingDots() {
  return (
    <span className="inline-flex gap-0.5">
      <span className="w-1.5 h-1.5 rounded-full bg-zinc-900 animate-bounce" style={{ animationDelay: "0ms" }} />
      <span className="w-1.5 h-1.5 rounded-full bg-zinc-900 animate-bounce" style={{ animationDelay: "150ms" }} />
      <span className="w-1.5 h-1.5 rounded-full bg-zinc-900 animate-bounce" style={{ animationDelay: "300ms" }} />
    </span>
  );
}
